import { GLOBAL_DEFAULT_SEO } from './defaults'
import type { ResolvedSeo, SeoAdminFields } from './types'
import { getDefaultOgImage, parseSchemaJson } from './utils'

function adminText(value?: string | null): string | undefined {
  const trimmed = value?.trim()
  return trimmed ? trimmed : undefined
}

/**
 * Priority: Admin SEO (DB) → auto-generated → global defaults.
 * Empty admin strings are treated as unset so fallbacks apply until DB is filled.
 * Once admin saves real SEO values, those replace generated fallbacks.
 */
export function resolveSeo(
  generated: Partial<ResolvedSeo>,
  admin?: SeoAdminFields | null,
): ResolvedSeo {
  const auto: ResolvedSeo = {
    ...GLOBAL_DEFAULT_SEO,
    ...generated,
    ogImage: generated.ogImage || getDefaultOgImage(),
  }

  const adminSchema = parseSchemaJson(admin?.schemaJson)

  const noIndex =
    admin?.noIndex != null ? Boolean(admin.noIndex) : (generated.noIndex ?? auto.noIndex)

  const noFollow =
    admin?.follow != null ? !admin.follow : (generated.noFollow ?? auto.noFollow)

  return {
    title: adminText(admin?.metaTitle) || auto.title,
    description: adminText(admin?.metaDescription) || auto.description,
    keywords: adminText(admin?.metaKeywords) || auto.keywords,
    canonical: adminText(admin?.canonicalUrl) || auto.canonical,
    ogImage: adminText(admin?.ogImage) || auto.ogImage,
    ogType: auto.ogType,
    ogLocale: auto.ogLocale,
    siteName: auto.siteName,
    twitterCard: auto.twitterCard,
    noIndex,
    noFollow,
    schema: adminSchema ?? auto.schema,
  }
}
